import { countryMapList } from '../data/countryMapList';

export const getEnrolmentPercentage = (enrolmentCount, maxRegistration) => {
  const percent = Math.floor((enrolmentCount / maxRegistration) * 100);
  if (percent >= 100) {
    return 'Full';
  }
  return percent;
};

export const getEnrolmentCountMap = (enrolmentList) => {
  let currentCount = 0;
  let pendingCount = 0;
  let transferredCount = 0;
  let canceledCount = 0;
  let completedCount = 0;

  enrolmentList.forEach((enrolment) => {
    if (enrolment.courseEnrolmentStatus === 'Current') {
      currentCount += 1;
    } else if (enrolment.courseEnrolmentStatus === 'Pending') {
      pendingCount += 1;
    } else if (enrolment.courseEnrolmentStatus === 'Completed') {
      completedCount += 1;
    } else if (enrolment.courseEnrolmentStatus === 'Transferred') {
      transferredCount += 1;
    } else if (
      enrolment.courseEnrolmentStatus === 'Withdrawn' ||
      enrolment.courseEnrolmentStatus === 'Cancelled' ||
      enrolment.courseEnrolmentStatus === 'Inactive'
    ) {
      canceledCount += 1;
    }
  });

  return {
    currentCount,
    pendingCount,
    completedCount,
    transferredCount,
    canceledCount,
  };
};

export const formatCourseEnrolmentCSVData = (data) => {
  const headers = [
    { label: 'First Name', key: 'firstName' },
    { label: 'Last Name', key: 'lastName' },
    { label: 'Country', key: 'country' },
    { label: 'Phone number', key: 'phoneNumber' },
    { label: 'Email', key: 'email' },
    { label: 'Status', key: 'status' },
    { label: 'LearnerId', key: 'learnerId' },
    { label: 'Laptop', key: 'laptop' },
    { label: 'Editing Software', key: 'editingSoftware' },
    { label: 'Camera', key: 'camera' },
    { label: 'Created At', key: 'createdAt' },
    { label: 'Updated At', key: 'updatedAt' },
  ];

  const rows = data.map((d) => {
    const { learner } = d;
    return {
      firstName: learner?.firstName,
      lastName: learner?.lastName,
      country: countryMapList[learner?.countryId]?.name,
      phoneNumber: learner?.phoneNumber,
      email: learner?.email,
      status: d?.courseEnrolmentStatus,
      learnerId: learner?.learnerId,
      laptop: learner?.extraInfo?.laptop?.type,
      editingSoftware: learner?.extraInfo?.editingSoftware?.type,
      camera: learner?.extraInfo?.camera?.type,
      createdAt: d?.createdAt,
      updatedAt: d?.lastModifiedTimeStamp,
    };
  });

  return {
    data: rows,
    headers,
    filename: `Course_Enrolment_Export.csv`,
  };
};
